import { render, staticRenderFns } from "./treeUnit.vue?vue&type=template&id=22ac42b6&scoped=true&"
import script from "./treeUnit.vue?vue&type=script&lang=ts&"
export * from "./treeUnit.vue?vue&type=script&lang=ts&"
import style0 from "./treeUnit.vue?vue&type=style&index=0&id=22ac42b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac42b6",
  null
  
)

export default component.exports